export default "__VITE_ASSET__BKY5VZe2__"